module.exports = __webpack_public_path__ + "img/more_report.7422129c.png";